import * as React from 'react';

interface IIconProps {
  type: string;
  className?: string;
  children?: any;
}

const Icon = (props: IIconProps) => {
  return (
    <span className={'icon icon--' + props.type + (props.className ? ' ' + props.className : '')}>
      {props.children}
    </span>
  );
};

export default Icon;



// WEBPACK FOOTER //
// ./src/modules/Icon/Icon.tsx